module.exports = __webpack_public_path__ + "img/login-illustration.43470049.svg";